import React from 'react';

import { useBreakpoint } from '@ast/magma/breakpoints';

import Times from '@ast/magma/components/icon/icons/Times';

import { Button } from '@ast/magma/components/button';
import { Overlay } from '@ast/magma/components/overlay';

import { useTranslation } from '@app/core/i18n';

import styles from './styles.pcss';

interface AccountsDropDownOverlayProps {
  readonly onClick?: React.MouseEventHandler<Element>
}

export const AccountsDropDownOverlay: React.FC<AccountsDropDownOverlayProps> = ({ onClick }) => {
  const isMobile = useBreakpoint().device === 'mobile';
  const { t } = useTranslation();

  return (
    <Overlay className={styles.overlay} align="center">
      {isMobile && (
        <Button
          aria-label={t(
            'close.aria-label|Aria-label for dropdown close button',
            'Close dropdown with accounts',
          )}
          className={styles.closeIcon}
          icon={<Times />}
          look="icon"
          onClick={onClick}
        />
      )}
    </Overlay>
  );
};
